import { render, staticRenderFns } from "./additional-activity.vue?vue&type=template&id=0b2ea16b&scoped=true&"
import script from "./additional-activity.vue?vue&type=script&lang=js&"
export * from "./additional-activity.vue?vue&type=script&lang=js&"
import style0 from "./additional-activity.vue?vue&type=style&index=0&id=0b2ea16b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ea16b",
  null
  
)

export default component.exports